<h2 mat-dialog-title>Leave Page?</h2>
<mat-dialog-content>
    <p>Changes you made may not be saved.</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: flex-end;">
    <button class="noBtn" mat-button (click)="onNoClick()">No</button>&nbsp;
    <button class="yesBtn" mat-button (click)="leavePage()">Leave</button>
</mat-dialog-actions>